import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

document.addEventListener(
    'DOMContentLoaded',
    () => {
        Swiper.use([Navigation, Pagination, Thumbs]);
        const sliders = document.querySelectorAll('.js-slider-history');
        sliders.forEach((slider) => {
            let swiperSlderNav;
            const wrapper = slider.closest('.swiper-container');
            const sliderNav = wrapper?.querySelector('.js-slider-history-nav');
            if (sliderNav !== null && sliderNav !== undefined) {
                swiperSlderNav = new Swiper(sliderNav, {
                    slidesPerView: 'auto',
                    speed: 500,
                    grabCursor: true,
                    spaceBetween: 10,
                    autoHeight: true,
                    breakpoints: {
                        768: {
                            spaceBetween: 30,
                        },
                    },
                });
            }

            const swiperSlder = new Swiper(slider, {
                slidesPerView: 'auto',
                speed: 500,
                grabCursor: true,
                autoHeight: true,
                navigation: {
                    nextEl: slider.querySelector('.swiper-button-next'),
                    prevEl: slider.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true,
                },
                thumbs: {
                    swiper: swiperSlderNav,
                },
            });
        });
    },
    { once: true },
);
